export interface IThemeDimensions {
  notification: {
    width: string
    height: string
    emptyHeight: number
  };
}

export const dimensions: IThemeDimensions = {
  notification: {
    width: '558px',
    height: '520px',
    emptyHeight: 160
  },
};
